export default "__VITE_ASSET__CHJVQu9q__"